module.exports = __webpack_public_path__ + "static/media/hi-loft.c3e78bf8.svg";